
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.083 7.697c-.622 1.271-.468 3.437-.28 4.594h7.687c.375.062 1.343-.032 1.75.624.329.532.346 1.343.03 1.938-.28.531-.947.667-1.218.688l-12.844-.063c-.906 0-1.656.031-2.718.688-1.523.94-3.189 2.93-3.22 7.937-.03 5.125 1.782 8.156 3.532 8.75.741.252 2.656.27 3.531.125 0-.896-.018-3.05.032-4 .062-1.188.494-2.558 1.343-3.719.938-1.281 2.857-2.256 4.344-2.468.656-.094 11-.063 11.5-.125.5-.063.995-.198 1.625-.625.969-.657 1.563-1.5 1.625-2.625.064-1.155.325-9.175.063-10.375-.22-1-.5-1.438-1.188-2.125-.687-.688-3.562-1.688-7.687-1.625-4.125.062-7.157.874-7.907 2.406z","stroke":"#000C1F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M31.917 40.523c.622-1.272.468-3.438.28-4.594H24.51c-.375-.063-1.343.031-1.75-.625-.329-.532-.346-1.343-.03-1.938.28-.531.947-.666 1.218-.687l12.844.062c.906 0 1.656-.031 2.718-.687 1.523-.94 3.189-2.932 3.22-7.938.03-5.125-1.782-8.156-3.532-8.75-.741-.251-2.656-.27-3.531-.125 0 .896.018 3.05-.032 4-.062 1.188-.494 2.558-1.343 3.719-.938 1.281-2.857 2.256-4.344 2.469-.656.094-11 .062-11.5.125-.5.062-.995.198-1.625.625-.969.656-1.563 1.5-1.625 2.625-.064 1.155-.325 9.174-.063 10.375.22 1 .5 1.437 1.188 2.125.687.687 3.562 1.687 7.687 1.625 4.125-.063 7.157-.875 7.907-2.407z","stroke":"#56BFC7","stroke-width":"2"}})])
          )
        }
      }
    